

export const chatbotService = {
  /**
   * Send a message to Fatou and get a response
   * @param {Array} messages - Array of message objects with role and content
   * @param {string} clientId - Legacy client ID
   * @param {string} visitorId - Stable visitor ID from localStorage
   * @param {string} sessionId - Current session ID
   * @returns {Promise<string>} - AI response
   */
  async sendMessage(messages, clientId, visitorId, sessionId) {

    try {
      const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
      const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

      if (!supabaseUrl || !supabaseAnonKey) {
        throw new Error('Configuration Supabase manquante');
      }

      const response = await fetch(`${supabaseUrl}/functions/v1/fatou-chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${supabaseAnonKey}`,
          'apikey': supabaseAnonKey
        },
        body: JSON.stringify({ 
          messages,
          clientId,
          visitorId: visitorId || null,
          sessionId: sessionId || null,
        })
      });

      const data = await response?.json()?.catch(() => ({}));

      console.log('Edge Function response:', {
        status: response?.status,
        ok: response?.ok,
        data
      });

      if (!response?.ok) {
        const errorMessage = data?.error || data?.message || `Erreur ${response?.status}`;
        const errorDetails = data?.details;
        
        console.error('Edge Function error response:', {
          status: response?.status,
          error: errorMessage,
          details: errorDetails
        });

        if (errorMessage?.includes('OPENAI_API_KEY not configured')) {
          throw new Error('⚠️ Configuration manquante: La clé API OpenAI n\'est pas configurée dans les secrets de la fonction Edge. Veuillez contacter l\'administrateur.');
        }

        if (errorMessage?.includes('invalid_api_key') || errorMessage?.includes('Incorrect API key')) {
          throw new Error('⚠️ Clé API invalide: La clé OpenAI configurée est incorrecte. Veuillez vérifier la configuration.');
        }

        if (errorMessage?.includes('insufficient_quota') || errorMessage?.includes('quota')) {
          throw new Error('⚠️ Quota dépassé: Le quota OpenAI est épuisé. Veuillez contacter l\'administrateur.');
        }

        if (response?.status === 401) {
          throw new Error('⚠️ Erreur d\'authentification OpenAI. Vérifiez la clé API.');
        }

        if (response?.status === 429) {
          throw new Error('⚠️ Trop de requêtes. Veuillez réessayer dans quelques instants.');
        }

        if (response?.status === 500) {
          throw new Error(`⚠️ Erreur serveur: ${errorMessage}`);
        }

        throw new Error(errorMessage);
      }

      if (!data?.message) {
        console.error('Invalid response structure:', data);
        throw new Error('Réponse invalide du serveur');
      }

      return data?.message;
    } catch (error) {
      console.error('Chatbot error:', error);
      
      if (error?.message?.startsWith('⚠️')) {
        throw error;
      }

      if (error?.message?.includes('fetch') || error?.message?.includes('network')) {
        throw new Error('⚠️ Problème de connexion. Vérifiez votre connexion internet.');
      }
      
      throw new Error('Désolée, je rencontre un problème technique. Veuillez réessayer dans un instant. 😔');
    }
  },

  /**
   * Get a greeting message from Fatou
   * @returns {string} - Greeting message
   */
  getGreeting() {
    return "Bonjour 👋 Je suis Fatou, l'assistante d'ADT Express. Nous organisons vos expéditions entre la France et Abidjan : barriques, cartons, électroménager et solutions professionnelles. Est-ce pour un envoi personnel ou dans un cadre professionnel ? Dites-moi simplement ce que vous souhaitez et j'organise tout pour vous 😊";
  }
};

export default chatbotService;